import type { FlowSummary } from "../types";

/** `delivery_errors` codes written by `send.py` and `tasks.py`. Unknown codes render verbatim. */
const DELIVERY_ERROR_REASONS: Record<string, string> = {
  recipient_blocked: "the recipient address is blocked",
  send_failed: "the email provider rejected it",
  pdf_not_stored: "the PDF was not stored",
  no_contact: "the merchant has no email on file",
};

const reason = (code: string | undefined): string =>
  (code && DELIVERY_ERROR_REASONS[code]) || code || "unknown error";

/**
 * Failure lines straight from `email_error` and `distribution`, never from
 * status. A stopped bundle keeps its pending marker, so S5 reports it as
 * `pending` with an `error`; an in-flight retry has no `error`.
 */
export function deliveryFailures(
  flow: Pick<
    FlowSummary,
    | "email_error"
    | "verification_error"
    | "verification_locked"
    | "distribution"
    | "has_merchant_link"
  >
): string[] {
  const lines: string[] = [];
  if (flow.email_error) {
    lines.push(`Invite email not delivered: ${reason(flow.email_error.code)}.`);
  }
  if (flow.verification_error) {
    lines.push(`Verification code not delivered: ${reason(flow.verification_error.code)}.`);
  }
  if (flow.verification_locked) {
    lines.push("Verification locked after too many incorrect codes; send a new flow.");
  }
  const { state, error } = flow.distribution;
  if (state === "failed" || (state === "pending" && error)) {
    const what = flow.has_merchant_link ? "Signed copies not sent" : "Document not emailed";
    lines.push(`${what}: ${reason(error)}.`);
  }
  return lines;
}
